const axios = require("axios");

const options = pin => ({
  method: 'GET',
  url: `https://nominatim.openstreetmap.org/search?postalcode=${pin}&format=json&addressdetails=1`,
  headers: { 'User-Agent': 'AulasApp/1.0' },
});


export const getAddressFromPin = async (pin, callback) => {
    await axios.request(options(pin)).then(function (response) {
        const data = response.data || [];
        const item = data[0];
        callback(
            item ? (item.address?.city || item.address?.county || item.address?.town || item.address?.village || "") : "",   // District (closest match)
            item ? (item.address?.state || "") : "",           // State
            item ? (item.address?.country || "") : "" // Country
        )
    }).catch(function (error) {
        console.error(error);
    });
}
